import React from 'react';
import ReactPaginate from 'react-paginate';

export default function ProductOverviewPagination({ totalPages, page, updateCurrentPage }) {
    const isLargeDesktop = window.matchMedia('(min-width: 1280px)').matches;

    return (
        <nav
            className="d-flex justify-content-between"
            aria-label="navigation"
            role="navigation"
        >
            <ReactPaginate
                previousLabel=""
                previousClassName="page-item page-item--prev"
                previousLinkClassName="page-link text-right"
                nextLabel=""
                nextClassName="page-item page-item--next"
                nextLinkClassName="page-link text-left"
                breakLabel="..."
                breakClassName="page-item"
                breakLinkClassName="page-link"
                containerClassName="pagination"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                activeClassName="active"
                disabledClassName="disabled"
                pageCount={totalPages}
                marginPagesDisplayed={isLargeDesktop ? 2 : 1}
                pageRangeDisplayed={isLargeDesktop ? 3 : 2}
                forcePage={page}
                onPageChange={(data) => {
                    updateCurrentPage(data);
                }}
                hrefBuilder={(page) => {
                    const searchParams = new URLSearchParams(location.search);
                    searchParams.set('page', page);
                    const searchParamsString = searchParams.toString();

                    return `?${searchParamsString}`;
                }}
            />
        </nav>
    );
}
